// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.documenttype.knowntypes

import org.multipaz.cbor.DataItem
import org.multipaz.documenttype.knowntypes.PaymentTransaction.Payload
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.Tstr
import org.multipaz.cbor.toDataItem
import org.multipaz.documenttype.knowntypes.PaymentTransaction.Payee
import org.multipaz.cbor.toDataItemDateTimeString
import org.multipaz.documenttype.knowntypes.PaymentTransaction.Pisp
import org.multipaz.cbor.toDataItemFullDate
import org.multipaz.documenttype.knowntypes.PaymentTransaction.Recurrence
import org.multipaz.documenttype.knowntypes.PaymentTransaction.MitOptions
import org.multipaz.documenttype.knowntypes.toDataItem
import org.multipaz.documenttype.knowntypes.fromDataItem

fun Payload.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "Zph2X7xiQtep5e4Ogo6Ul6s67kQO0WN_D5r9-zAbPXU")
val Payload_cborSchemaId = ByteString(102, -104, 118, 95, -68, 98, 66, -41, -87, -27, -18, 14, -126, -114, -108, -105, -85, 58, -18, 68, 14, -47, 99, 127, 15, -102, -3, -5, 48, 27, 61, 117)

fun Payload.Companion.fromCbor(data: ByteArray): Payload {
    return Payload.fromDataItem(Cbor.decode(data))
}

val Payload.Companion.cborSchemaId: ByteString
    get() = Payload_cborSchemaId

fun Payload.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("transactionId", Tstr(this.transactionId))
    builder.put("currency", Tstr(this.currency))
    builder.put("amount", this.amount.toDataItem())
    builder.put("payee", this.payee.toDataItem())
    val dateTime = this.dateTime
    if (dateTime != null) {
        builder.put("dateTime", dateTime.toDataItemDateTimeString())
    }
    val pisp = this.pisp
    if (pisp != null) {
        builder.put("pisp", pisp.toDataItem())
    }
    val executionDate = this.executionDate
    if (executionDate != null) {
        builder.put("executionDate", executionDate.toDataItemFullDate())
    }
    val amountEstimated = this.amountEstimated
    if (amountEstimated != null) {
        builder.put("amountEstimated", amountEstimated.toDataItem())
    }
    val amountEarmarked = this.amountEarmarked
    if (amountEarmarked != null) {
        builder.put("amountEarmarked", amountEarmarked.toDataItem())
    }
    val sctInst = this.sctInst
    if (sctInst != null) {
        builder.put("sctInst", sctInst.toDataItem())
    }
    val tipRequested = this.tipRequested
    if (tipRequested != null) {
        builder.put("tipRequested", tipRequested.toDataItem())
    }
    val recurrence = this.recurrence
    if (recurrence != null) {
        builder.put("recurrence", recurrence.toDataItem())
    }
    val mitOptions = this.mitOptions
    if (mitOptions != null) {
        builder.put("mitOptions", mitOptions.toDataItem())
    }
    return builder.end().build()
}

fun Payload.Companion.fromDataItem(dataItem: DataItem): Payload {
    val transactionId = dataItem["transactionId"].asTstr
    val currency = dataItem["currency"].asTstr
    val amount = dataItem["amount"].asDouble
    val payee = Payee.fromDataItem(dataItem["payee"])
    val dateTime0 = if (dataItem.hasKey("dateTime")) {
        dataItem["dateTime"].asDateTimeString
    } else {
        null
    }
    val pisp0 = if (dataItem.hasKey("pisp")) {
        Pisp.fromDataItem(dataItem["pisp"])
    } else {
        null
    }
    val executionDate0 = if (dataItem.hasKey("executionDate")) {
        dataItem["executionDate"].asDateString
    } else {
        null
    }
    val amountEstimated0 = if (dataItem.hasKey("amountEstimated")) {
        dataItem["amountEstimated"].asBoolean
    } else {
        null
    }
    val amountEarmarked0 = if (dataItem.hasKey("amountEarmarked")) {
        dataItem["amountEarmarked"].asBoolean
    } else {
        null
    }
    val sctInst0 = if (dataItem.hasKey("sctInst")) {
        dataItem["sctInst"].asBoolean
    } else {
        null
    }
    val tipRequested0 = if (dataItem.hasKey("tipRequested")) {
        dataItem["tipRequested"].asBoolean
    } else {
        null
    }
    val recurrence0 = if (dataItem.hasKey("recurrence")) {
        Recurrence.fromDataItem(dataItem["recurrence"])
    } else {
        null
    }
    val mitOptions0 = if (dataItem.hasKey("mitOptions")) {
        MitOptions.fromDataItem(dataItem["mitOptions"])
    } else {
        null
    }
    return Payload(
        transactionId = transactionId,
        currency = currency,
        amount = amount,
        payee = payee,
        dateTime = dateTime0,
        pisp = pisp0,
        executionDate = executionDate0,
        amountEstimated = amountEstimated0,
        amountEarmarked = amountEarmarked0,
        sctInst = sctInst0,
        tipRequested = tipRequested0,
        recurrence = recurrence0,
        mitOptions = mitOptions0,
    )
}
